import { classNames, localeMoment } from "../../helpers";
import SessionModel from "../../api/models/SessionModel";
import { ClockIcon, CalendarIcon } from "@heroicons/react/solid";
import { getSessionState } from "./helper";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import { isValidMoment } from "../../helpers/date_helpers";

type SessionCardProps = {
  session: SessionModel;
  userType: "student" | "tutor";
  isSessionIdShown: boolean;
};

export default function SessionCard({
  session,
  userType,
  isSessionIdShown,
}: SessionCardProps) {
  return (
    <li
      className={classNames(
        "bg-white",
        session.isComing && "bg-brandblue-200 text-brandblue-500 ",
        session.isScheduled && "opacity-50",
        session.isDone || session.isInProgress
          ? "hover:bg-gray-100"
          : "cursor-not-allowed"
      )}
      data-cy="sessionCard"
      data-cy-session-status={session.status}
      data-cy-session-id={session.id}
    >
      <div className="relative  px-6 py-5  items-center focus-within:ring-2 focus-within:ring-inset focus-within:ring-brandblue-500">
        <div className="flex-shrink-0 flex items-center justify-between ">
          <h1
            className={classNames(
              "font-bold text-2xl flex",
              session.isComing && "text-brandblue-900"
            )}
          >
            <span>#</span>
            <span>{session.sessionNumber}</span>
          </h1>
          {getSessionState(session.status!)}
        </div>
        <div className="flex-1 ">
          <div className="w-full pt-2 text-justify">
            <p
              className={classNames(
                "text-sm font-medium text-gray-900 py-2",
                !session.isDone && "hidden"
              )}
            >
              <span>{`${session.startPageNumber || 0} - `}</span>
              <span>{session.endPageNumber || ""}</span>
            </p>
          </div>
          {userType === "tutor" && (
            <div className="mt-4 flex gap-3">
              <UserProfilePictureAvatar
                profilePictureUrl={session.student?.profile_picture_url}
                className="w-8 h-8"
                alt="sand-user-img"
              />
              <div className="flex items-center">
                <h3 className="text-sm font-medium text-gray-700">
                  {session.student?.fullName}
                </h3>
              </div>
            </div>
          )}
          <div
            className={classNames(
              session.isComing && "text-brandblue-500 ",
              "py-2 flex  items-center justify-between text-gray-700 "
            )}
          >
            <div className="  flex rounded-full items-center justify-between">
              <CalendarIcon className="w-[18px]  rtl:ml-1 ltr:mr-1" />

              {localeMoment(session!.date!).format("ddd L")}
            </div>
            {isValidMoment(session.start_time) && (
              <div className=" p-1 px-2 flex rounded-full items-center justify-between">
                <ClockIcon className="w-[18px] rtl:ml-1 ltr:mr-1" />
                {localeMoment(session!.start_time!).format("hh:mm A")}
              </div>
            )}
          </div>
        </div>
      </div>
    </li>
  );
}
